import React from 'react';
import {
  Card,
  Col,
  Row,
  Button,
} from 'reactstrap';
import './FundingInstructions.scss';
import Translate from '@securitize/ui-components/i18n/Translate/Translate';
import { useSelector } from 'react-redux';
import news from './assets/news.svg';

const FundingInstructions = () => {
  const { issuerConfig } = useSelector((state) => ({
    issuerConfig: state.issuerConfiguration.config,
  }));

  return (
    <Row className="funding-instructions">
      <Card className="funding-instructions__card">
        <Col
          className="funding-instructions__card__logo"
          xl="auto"
          lg="auto"
          md="auto"
          sm="auto"
        >
          <img src={news} alt="" />
        </Col>
        <Col
          xl={9}
          lg={9}
          md={9}
          sm={12}
          className="funding-instructions__card__description-col"
        >
          <h5 className="funding-instructions__card__description-col__title">
            <Translate translationKey="Texts.accreditation-required" />
          </h5>
          <p className="funding-instructions__card__description-col__text">
            <Translate translationKey="Texts.accreditation-required-descripton" />
          </p>
        </Col>
        <Col xl={2} lg={2} md={2} sm={12} className="funding-instructions__card__button-col">
          <Button
            onClick={() => {
              window.open(issuerConfig.marketsAccreditationUrl);
            }}
            className="funding-instructions__card__button-col__button"
          >
            <Translate translationKey="Texts.accreditation-banner-button" />
          </Button>
        </Col>
      </Card>
    </Row>
  );
};

export default FundingInstructions;
